"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$CSPScripts = void 0;
const jotai_1 = require("jotai");
exports.$CSPScripts = (0, jotai_1.atom)({
    'tea-precollect': '',
    'slardar-precollect': '',
    'remix-route-modules': '',
    'remix-server-handoff': '',
});
exports.$CSPScripts.debugLabel = '$CSPScripts';
